// Framework
import { AppContainer } from 'components/style/Containers.style';
import { DashboardNavbar } from './Navigation.style';
import LanguageToggle from './LanguageToggle/LanguageToggleContainer';
import LogoMenu from './LogoMenu/LogoMenuContainer';
import PropTypes from 'prop-types';
import React from 'react';
import UserDropdown from './UserDropdown/UserDropdownContainer';

/**
 * A list of field rows with a header.
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {Element} Stateless functional React component.
 */
const Navigation = ({ color }) => (
  <DashboardNavbar backgroundcolor={color}>
    <AppContainer>
      <LogoMenu />
      <LanguageToggle />
      <UserDropdown />
    </AppContainer>
  </DashboardNavbar>
);

Navigation.contextTypes = {
  t: PropTypes.func.isRequired
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/NavigationComponent.js